import { Injectable } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { PayRateModel, PayRateSetModel } from '@bayclubs/group-classes-employee-api';

@Injectable({
    providedIn: 'root'
})
export class ProviderPayratesFormBuilderService {
    constructor(private formBuilder: UntypedFormBuilder) {}

    createForm(payRates: PayRateSetModel) {
        const template =
            payRates ||
            <PayRateSetModel>{
                payRates: []
            };
        return this.formBuilder.group({
            validFrom: [null, Validators.required],
            payRates: this.formBuilder.array(template.payRates.map(payRate => this.createPayRateFormGroup(payRate)))
        });
    }

    createPayRateFormGroup(payRate: PayRateModel = null): UntypedFormGroup {
        const template = payRate || { groupClassCategory: {} } as PayRateModel;

        return this.formBuilder.group({
            hourlyRate: [template.hourlyRate, Validators.required],
            categoryCode: [template.groupClassCategory, Validators.required]
        });
    }

    addCategorySpecificPayRate(form: UntypedFormGroup) {
        const payRates = form.get('payRates') as UntypedFormArray;
        payRates.push(this.createPayRateFormGroup());
    }

    removeCategorySpecificPayRate(form: UntypedFormGroup, index: number) {
        const payRates = form.get('payRates') as UntypedFormArray;
        payRates.removeAt(index);
    }
}